import * as React from "react";

import { Wrapper } from "../../../components";
import "./Functions.css";

export interface FunctionsProps {
  children: React.ReactChild[];
  thumbnailSrc: string;
  toggleVideoExpand: () => void;
}

const Functions = (props: FunctionsProps): JSX.Element => (
  <Wrapper>
    <h1 className="title">
      khám phá <b>Tính năng</b>
    </h1>
    <div className="content">
      <div className="row">
        <div className="col-sm-6">
          <div className="feature-video">
            <div className="feature-video__container">
              <img
                className="feature-video__placeholder img-responsive"
                src={props.thumbnailSrc}
              />
              <span
                className="feature-video__play-icon"
                onClick={props.toggleVideoExpand}
              >
                <i className="fa fa-play icon" />
              </span>
            </div>
            <h1>
              <b>Thiết kế cao cấp -</b>{" "}
              <span>
                <b>Nâng tầm thương hiệu</b>
              </span>
            </h1>
          </div>
        </div>
        <div className="col-sm-6">{props.children}</div>
      </div>
    </div>
  </Wrapper>
);

export default Functions;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/Functions.tsx